import { render, staticRenderFns } from "./LinkInput.vue?vue&type=template&id=6f0c5ca1&scoped=true&"
import script from "./LinkInput.vue?vue&type=script&lang=js&"
export * from "./LinkInput.vue?vue&type=script&lang=js&"
import style0 from "./LinkInput.vue?vue&type=style&index=0&id=6f0c5ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c5ca1",
  null
  
)

export default component.exports